export default "__VITE_ASSET__97b362f1__"